<template>
  <div class="flex-row-space-between-hCenter home-header"
       :style="{backgroundColor: scrollTop > 200 ? 'rgba(255, 255, 255, 0.86)' : 'transparent', boxShadow: scrollTop > 200 ? '0 0 10px rgba(0,0,0,0.1)' : 'none'}">
    <div @click="goHome()" class="left">
      <img class="logo" src="@/assets/logo.png" alt="">
      <img class="home_title" src="@/assets/home/home_title.png" alt="">
    </div>
    <div class="right">
      <!-- 登录注册按钮-->
      <el-button @click="onAuditProcess()" type="default" size="small">审核进度查询</el-button>
      <el-button @click="onLogin()" type="primary" size="small">登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-header",
  props: {
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  methods: {
    goHome() {
      const path = this.$route.path
      // 相同路由
      if (path === '/home') {
        return
      }
      // 表单页面
      const pathBList = ['/apply/step-one', '/apply/step-two', '/apply/confirm-info']
      if (pathBList.includes(path)) {
        return this.$confirm('离开当前页面，数据将会丢失, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.replace({
            path: '/'
          })
        })
      }
      this.$router.replace({
        path: '/'
      })
    },
    // 跳转公会端登录
    onLogin() {
      const VUE_APP_ORG_URL = process.env.VUE_APP_ORG_URL
      window.open(VUE_APP_ORG_URL, '_blank')
    },
    // 查看审核进度
    onAuditProcess() {
      this.$router.push('/audit/process')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 14px 20px;
}

.left {
  cursor: pointer;

  .logo {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .home_title {
    width: 128px;
    height: 28px;
    margin-left: 4px;
    object-fit: contain;
  }
}

.right {

}
</style>